import { render, staticRenderFns } from "./menuFill.vue?vue&type=template&id=2f48e352"
import script from "./menuFill.vue?vue&type=script&lang=js"
export * from "./menuFill.vue?vue&type=script&lang=js"
import style0 from "./menuFill.vue?vue&type=style&index=0&id=2f48e352&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports